import PropTypes from 'prop-types';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
var Image = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-89u3bx-0"
})(["position:absolute;top:50%;transform:translateY(-50%);left:", ";right:", ";margin-bottom:0;@media only screen and (max-width:", "px){position:static;transform:none;max-width:150%;}"], function (_ref) {
  var rightToLeft = _ref.rightToLeft;
  return rightToLeft ? null : 0;
}, function (_ref2) {
  var rightToLeft = _ref2.rightToLeft;
  return rightToLeft ? 0 : null;
}, spacing.collapseMenuWidth);
Image.propTypes = {
  src: PropTypes.string.isRequired,
  rightToLeft: PropTypes.bool,
  alt: PropTypes.string.isRequired
};
export default Image;